import DescriptionManage from './DescriptionManage';

export default DescriptionManage;
export { DescriptionManage };
